import { render, staticRenderFns } from "./ThankyouPageAdsTab.vue?vue&type=template&id=27f9a970&scoped=true"
import script from "./ThankyouPageAdsTab.vue?vue&type=script&lang=js"
export * from "./ThankyouPageAdsTab.vue?vue&type=script&lang=js"
import style0 from "./ThankyouPageAdsTab.vue?vue&type=style&index=0&id=27f9a970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f9a970",
  null
  
)

export default component.exports